type RegistrationErrorLike = {
  data?: {
    code?: unknown;
    message?: unknown;
    errors?: unknown;
  };
};

const GENERIC_FALLBACK = 'Registration failed. Please try again.';

/**
 * Registration hardening (Asana 1218634285737762). POST /auth/beta-register
 * answers 400 { status, code: "REGISTRATION_BLOCKED", message } for all three
 * rules (anonymized connection, per-IP signup limit, recently banned IP). The
 * body never says which rule fired, and neither does the copy: one string for
 * all three, final per Decision 12. Key on the top-level `code` and ignore the
 * backend `message`.
 */
export const REGISTRATION_BLOCKED_CODE = 'REGISTRATION_BLOCKED';

export const REGISTRATION_BLOCKED_MESSAGE =
  "We can't create an account from this connection. If you think this is a mistake, contact support@trademagic.gg.";

export const getRegistrationErrorMessage = (error: unknown): string => {
  const data = (error as RegistrationErrorLike | null | undefined)?.data;
  if (!data) return GENERIC_FALLBACK;

  if (data.code === REGISTRATION_BLOCKED_CODE) return REGISTRATION_BLOCKED_MESSAGE;

  // Everything below is the behaviour PasswordStep had before the code check
  // existed: pass the backend message through, else join field errors.
  if (data.message) return data.message as string;

  if (data.errors && typeof data.errors === 'object') {
    try {
      return Object.values(data.errors as Record<string, unknown>).join(', ');
    } catch {
      return GENERIC_FALLBACK;
    }
  }

  return GENERIC_FALLBACK;
};
